import BirdieImage from '@/assets/birdie.svg';
import { Text, Title } from '@mantine/core';

import styles from './index.module.css';
import useIntl from "@infrastructure/hooks/useIntl.ts";

const AirTransportBookingSuccess = () => {
    const t = useIntl("transportList");
  return (
    <div className={styles.container}>
      <div className={styles['content-container']}>
        <Title order={1}>{t('booking.congratulations')}</Title>
        <Text c="d1gray.6">{t('booking.bookingSuccess')}</Text>
      </div>
      <div className={styles['home-image']}>
        <BirdieImage />
      </div>
    </div>
  );
};

export default AirTransportBookingSuccess;
